import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import DeliveryPerson from "../../../entities/DeliveryPerson";
import ArticleWarehouse from "../../../entities/productOrder/article/ArticleWarehouse";
import TransferArticleRequest from "../../../model/transaction/TransferArticleRequest";
import { ArticleWarehouseService } from "../../../service/ArticleWarehouseService";
import { TransferArticleItem } from "../TransferArticleButton/TransferArticleStore";
import ArticleStockRequest from "../../../model/transaction/ArticleStockRequest";

class TransferArticleFromWarehouseStore {

    public articles: TransferArticleItem[] = [];
    public comment?: string;
    public articleWarehouse: ArticleWarehouse;
    public to?: DeliveryPerson;
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;
    public amountError?: string;
    public articleError?: string;
    public fromError?: string;
    public toError?: string;
    public error?: string;


    constructor(commonStore: CommonStore, articleWarehouse: ArticleWarehouse) {
        this.articleWarehouse = articleWarehouse;
        this.isModalOpen = false;
        this.loading = false;
        this.commonStore = commonStore;
        this.articles = [];
        makeAutoObservable(this);
    }

    get enableButton(): boolean {
        return !!(this.to && this.articles.length > 0 && this.articles.every(item => item.article && item.amount && item.amount !== 0));
    }

    @action
    public addArticleItem() {
        const newItem: TransferArticleItem = {
            id: `${Date.now()}-${Math.random()}`,
            article: undefined,
            amount: undefined,
            articleError: undefined,
            amountError: undefined
        };
        this.articles.push(newItem);
    }

    @action
    public async openModal() {
        this.loading = true;
        this.isModalOpen = true;
        if (this.articles.length === 0) {
            this.addArticleItem();
        }
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public async cleanModal() {
        this.comment = undefined;
        this.articles = [];
        this.to = undefined;
        this.error = undefined;
        this.amountError = undefined;
        this.articleError = undefined;
        this.fromError = undefined;
        this.toError = undefined;
    }


    @action
    public async save(): Promise<boolean> {
        if (!this.to) {
            this.toError = "TO_REQUIRED";
            return false;
        }

        // Validar artigos
        let hasErrors = false;
        for (const item of this.articles) {
            item.articleError = undefined;
            item.amountError = undefined;

            if (!item.article) {
                item.articleError = "ARTICLE_REQUIRED";
                hasErrors = true;
            }
            if (!item.amount || item.amount === 0) {
                item.amountError = "AMOUNT_REQUIRED";
                hasErrors = true;
            }
        }

        if (this.articles.length === 0) {
            this.error = "ARTICLES_REQUIRED";
            return false;
        }

        if (hasErrors) {
            return false;
        }

        // Salvar todos os artigos
        this.loading = true;
        try {
            const articles = this.articles
                .filter(article => article && article.article && article.amount && article.amount !== 0)
                .map(article => {
                    return new ArticleStockRequest(
                        article.article!!.articleId,
                        article.amount!!
                    )
                })
            const request: TransferArticleRequest = {
                to: this.to.id,
                articles,
                comment: this.comment
            };
            const response = await ArticleWarehouseService.transferArticle(this.articleWarehouse.id, request);
            this.commonStore.processErrors(response);
            this.loading = false;
            return response.success;
        } catch (error) {
            this.loading = false;
            this.error = "TRANSFER_ERROR";
            return false;
        }
    }
}

export default TransferArticleFromWarehouseStore;

